import defaultConfig from '.';

export default {
  ...defaultConfig,
  publisherdeskLib: 'https://cdn.tpdads.com/configs/ledenicheur.js',
  loadGDPRScript: true,
};
